module.exports = __webpack_public_path__ + "img/at_icon1.5bfde21f.png";